import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=e5a6a0c2"
import script from "./perfil.vue?vue&type=script&lang=js"
export * from "./perfil.vue?vue&type=script&lang=js"
import style0 from "./perfil.vue?vue&type=style&index=0&id=e5a6a0c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports